import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { type HeaderGroup } from "react-table";

interface Props {
  headerGroups: HeaderGroup<object>[];
  alignRight?: boolean;
}

const TableHead = ({ headerGroups, alignRight }: Props) => {
  return (
    <thead className="sticky top-0 z-[1] bg-surface">
      {headerGroups.map((headerGroup) => {
        const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
        return (
          <tr key={key} {...headerGroupProps}>
            {(headerGroup.headers as any[]).map((header) => {
              const { key, ...toggleProps } = header.getHeaderProps(
                header.getSortByToggleProps()
              );
              return (
                <th
                  scope="col"
                  key={key}
                  className="relative border-b border-border-subtle bg-surface px-2 py-2.5 text-sm font-bold text-gray-900"
                  {...toggleProps}
                  {...header.getHeaderProps({
                    style: {
                      maxWidth: header.maxWidth,
                      minWidth: header.minWidth,
                      width: header.width,
                    },
                  })}
                >
                  <div
                    className={`flex items-center ${
                      !alignRight && "justify-center"
                    } gap-2 whitespace-nowrap`}
                  >
                    <div>{header.render("Header")}</div>
                    <span className="inline-flex rounded text-gray-400">
                      <div className="mobile:w-5">
                        {!header.disableSortBy ? (
                          header.isSorted && !header.isSortedDesc ? (
                            <ChevronUpIcon
                              className="h-5 w-5 cursor-pointer"
                              aria-hidden="true"
                            />
                          ) : (
                            <ChevronDownIcon
                              className="h-5 w-5 cursor-pointer"
                              aria-hidden="true"
                            />
                          )
                        ) : (
                          <div />
                        )}
                      </div>
                    </span>
                  </div>
                </th>
              );
            })}
          </tr>
        );
      })}
    </thead>
  );
};

export default TableHead;
